import type { MapEcotrapType } from "./types";

/**
 * Соответствие номера тропы и записи в Strapi.
 *
 * Нумерация — с официальной «Карты экотроп курорта Мамисон» (файл со страницы
 * карты): параметры троп в Strapi совпадают с легендой карты до минуты и
 * метра, и по этим же номерам подписаны кружки на летней схеме.
 *
 * Все 9 троп заведены в Strapi (slug'и сверены со stage). Кружок стоит на схеме
 * всегда, кликабельным становится, когда экотропа с таким slug есть в данных.
 */
export const SUMMER_ECO_POINTS = [
  // Зарамаг, круговой, 1 км, 30 мин, перепад 60 м
  { number: "1", slug: "zaramag" },
  // Пик 2727, радиальный, 3,8 км, 2 ч, перепад 240 м
  { number: "2", slug: "pik-2727" },
  // Тропа желаний, радиальный, 2,5 км, 1 ч, перепад 100 м
  { number: "3", slug: "tropa-zhelanij" },
  // Мамихдон, линейный, 4,8 км, 2 ч 30 мин, перепад 540 м
  { number: "4", slug: "mamihdon" },
  // Лисри, линейный, 3,1 км, 1 ч 20 мин, перепад 110 м
  { number: "5", slug: "lisri" },
  // К кошаре, 3 км, 2 ч, перепад 455 м
  { number: "6", slug: "k-koshare" },
  // Панорамная к Лисри, 4,2 км, 2 ч 30 мин, перепад 737 м
  { number: "7", slug: "panoramnaya-k-lisri" },
  // К водопаду Клиат, 3 км, 3 ч 30 мин, перепад 481 м
  { number: "8", slug: "k-vodopadu-kliat" },
  // Тиб, 7,8 км, 4 ч, перепад 562 м
  { number: "9", slug: "tib" },
];

/** Индекс экотропы в mapData.ecotraps по номеру на схеме, -1 — если её нет */
export const findEcotrapIndexByNumber = (
  ecotraps: MapEcotrapType[] | undefined,
  number: string | null,
) => {
  const point = SUMMER_ECO_POINTS.find((item) => item.number === number);

  if (!point || !ecotraps) {
    return -1;
  }

  return ecotraps.findIndex((item) => item.slug === point.slug);
};

/** Номер на схеме для экотропы, найденной в данных */
export const getEcotrapNumber = (ecotrap?: MapEcotrapType | null) =>
  SUMMER_ECO_POINTS.find((item) => item.slug === ecotrap?.slug)?.number;
